import api from '../../utils/axios';

const documentTypes = async () => {
	const { data } = await api.get(`/document-types`);

	return data;
};

const documentsByClientExpert = async (clientId, expertId, uploadedBy) => {
	const { data } = await api.get(
		`/documents-uploaded?search[clientId]=${clientId}&search[expertId]=${expertId}&search[documentTypeId]=9d4d47d6-acfb-4d4b-bb77-876fedc9cc21&search[uploadedBy]=${uploadedBy}`
	);

	return data;
};

const documentsByClientID = async (clientId) => {
	const { data } = await api.get(
		`/documents-uploaded?search[clientId]=${clientId}&search[uploadedBy]=client`
	);

	return data;
};

const documentListById = async (documentsId) => {
	let ids = '';

	documentsId.forEach((id) => {
		if (ids === '') ids += `search[id]=${id}`;
		else ids += `&search[id]=${id}`;
	});

	const { data } = await api.get(`/documents-uploaded/list/id?${ids}`);

	return data;
};

const fileListById = async (filesId) => {
	let ids = '';

	filesId.forEach((id) => {
		if (ids === '') ids += `search[key]=${id}`;
		else ids += `&search[key]=${id}`;
	});

	const { data } = await api.get(`/files?${ids}`);

	return data;
};

const uploadFile = async (file, s3SignedUrl) => {
	const { data } = await api.putFile(s3SignedUrl, file, {
		authorization: false,
		headers: { 'Content-Type': file.type },
	});

	return data;
};

const generateUploadLinks = async (fileNames) => {
	const { data } = await api.post(`/files`, {
		fileNames,
	});

	return data;
};

const deleteFile = async (fileKey) => api.delete(`/files/${fileKey}`);

const deleteDocumentUploadedByID = async (id) =>
	api.delete(`/documents-uploaded/${id}`);

const createDocumentUploaded = async (
	fileName,
	fileKey,
	documentTypeId,
	clientId,
	expertId,
	uploadedBy,
	comment = ''
) => {
	const { data } = await api.post(`/documents-uploaded`, {
		name: fileName,
		fileKey,
		comment,
		uploadDate: new Date().toISOString(),
		documentTypeId,
		clientId,
		expertId,
		uploadedBy,
	});

	return data;
};

const downloadS3Object = async (url) => {
	const { data } = await api.get(url, {
		authorization: true,
		responseType: 'blob',
	});

	return data;
};

const documentService = {
	documentTypes,
	documentsByClientID,
	documentListById,
	fileListById,
	uploadFile,
	createDocumentUploaded,
	deleteFile,
	deleteDocumentUploadedByID,
	downloadS3Object,
	generateUploadLinks,
	documentsByClientExpert,
};

export default documentService;
